import { Box, CircularProgress, Tooltip, Typography } from '@mui/material';
import React from 'react';
import * as styles from './HeroMetricCard.styles';

export interface HeroMetricCardProps {
  label: string;
  count: number;
  selected: boolean;
  onClick: () => void;
  infoTooltip?: string;
  isLoading?: boolean;
  'data-testid'?: string;
}

export const HeroMetricCard: React.FC<HeroMetricCardProps> = ({
  label,
  count,
  selected,
  onClick,
  infoTooltip,
  isLoading = false,
  'data-testid': dataTestId,
}) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <Box
      display="flex"
      flex="1"
      role="button"
      tabIndex={0}
      aria-pressed={selected}
      aria-label={label}
      data-testid={dataTestId}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      sx={styles.card(selected)}
    >
      <Box sx={styles.labelRow}>
        <Typography variant="body2" sx={styles.label}>
          {label}
        </Typography>
        {infoTooltip ? (
          <Tooltip title={infoTooltip}>
            <Box
              component="span"
              className="uil uil-info-circle"
              data-testid="hero-metric-card-info"
              sx={styles.infoIcon}
            />
          </Tooltip>
        ) : null}
      </Box>
      {isLoading ? (
        <CircularProgress size={28} data-testid="hero-metric-card-loading" />
      ) : (
        <Typography sx={styles.count}>{count}</Typography>
      )}
    </Box>
  );
};
